<template>
  <com-page>
    <com-card>
      <div class="mb-15px">
        <h3 v-if="type === 'created'">创建网点</h3>
        <h3 v-if="type === 'edit'">编辑网点</h3>
        <div class="mb-20px" v-if="type === 'watch'">
          <el-tabs v-model="activeName">
            <el-tab-pane label="基本信息" name="1"></el-tab-pane>
            <el-tab-pane label="设备管理" name="2"></el-tab-pane>
            <el-tab-pane label="订单管理" name="3"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="site-edit_wrapper" v-if="activeName === '1'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
          <el-form-item label="是否新版逻辑" prop="newLogicFlag">
            <el-select
              v-model="ruleForm.newLogicFlag"
              placeholder="请选择是否走新版逻辑"
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="公司资产" prop="companyAssets">
            <el-select 
              v-model="ruleForm.companyAssets" 
              placeholder="请选择是否为公司资产"
            >
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属小区" prop="type">
            <el-select
              v-model="ruleForm.refResidentialArea"
              :disabled="disabled"
              placeholder="请输入并选择所属小区"
              filterable
              remote
              :remote-method="getSiteType"
              :loading="loading"
              style="width: 500px"
            >
              <el-option
                :label="item.name"
                :value="item.code"
                v-for="(item, index) in siteType"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网点图片" prop="photo">
            <com-upload
              :disabled="disabled"
              :originData="ruleForm.photo"
              @postImage="postImg"
              @deleteImageUrl="delImg"
            ></com-upload>
          </el-form-item>
          <el-form-item label="网点名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              :disabled="disabled"
              placeholder="请输入网点名称"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="网点编号">
            <el-input
              v-model="ruleForm.number"
              disabled
              placeholder="网点编号自动生成"
              style="width: 500px"
            ></el-input>
          </el-form-item>
          <el-form-item label="网点地址" prop="address">
            <div>
              <el-input
                v-model="ruleForm.address"
                disabled
                placeholder="请输入网点地址"
                @change="handleAddress"
                style="width: 500px"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="h-400px" style="overflow: hidden">
              <com-qq-map
                ref="qqMap"
                @latlng="handleMap"
                @address="getMapAddress"
                :coordinate="{ lat: ruleForm.addressLat, lng: ruleForm.addressLon }"
              ></com-qq-map>
            </div>
          </el-form-item>
          <div class="flex justify-end">
            <el-button @click="resetForm('ruleForm')">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="disabled"
              >确认</el-button
            >
          </div>
          <el-form-item> </el-form-item>
        </el-form>
      </div>
      <div v-if="activeName === '2'">
        <el-tabs v-model="deviceActiveName" type="card">
          <el-tab-pane label="充电桩" name="1"></el-tab-pane>
          <el-tab-pane label="监控" name="2"></el-tab-pane>
          <el-tab-pane label="消防" name="3"></el-tab-pane>
        </el-tabs>

        <ChargingStation v-if="deviceActiveName === '1'" :siteDefaultParams="siteDefaultParams"></ChargingStation>
        <Minitor v-if="deviceActiveName === '2'" :siteDefaultParams="siteDefaultParams"></Minitor>
        <FireFighting v-if="deviceActiveName === '3'" :siteDefaultParams="siteDefaultParams"></FireFighting>
      </div>
      <div v-if="activeName === '3'">
        <com-order-search
          typeOfView="site"
          @search="handleSearch"
          @onExport="handleExport"
        ></com-order-search>
        <com-order-list
          ref="table"
          :api="orderApi"
          :default-params="orderDefaultParams"
        ></com-order-list>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import { orderListApi } from '@/api/order'
import { addSiteApi, updateSiteApi, siteTypeApi, rebootEquApi } from '@/api/site'
import { communityListApi } from '@/api/community'
import { siteOtaUpgradeApi } from '@/api/equ'

import utils from 'my-tools-library'
import theVoiceDialog from './components/the-voice-dialog'

import ChargingStation from './device-manage/charging-station/index.vue'
import Minitor from './device-manage/minitor/index.vue'
import FireFighting from './device-manage/fire-fighting/index.vue'

export default {
  components: { theVoiceDialog, ChargingStation, Minitor, FireFighting },
  data() {
    return {
      orderApi: orderListApi,
      orderDefaultParams: {},
      type: '',
      activeName: '1',
      deviceActiveName: '1',
      disabled: false,
      regionId: [],
      region: '',
      ruleForm: {
        pwd: '', // 密码
        photo: '', // 网点图片
        name: '', // 网点名称
        area: '', // 所在区域
        address: '', // 地址
        projectLeader: '', // 负责人
        effectiveTime: '', // 生效时间
        expireTime: '', // 到期时间
        fullPrepayAmount: '', // 充满自停预付费金额
        rent: '', // 租金
        refBusiness: '', // 商家
        serviceCharge: '', // 服务费
        payType: '1', // 付费方式
        payMode: 1, // 付费模式
        addressLon: '', // 经度
        addressLat: '', // 纬度
        electricCharge: '', // 电费
        code: '',
        id: '',
        areaCodes: [],
        contactNumber: '', // 联系电话
        refResidentialArea: '', // 所属小区
        divideType: 1, // 分成类型
        number: '', // 网点编号
        refChargePlanBatch: '', // 充值套餐
        newLogicFlag: 1, // 是否走新版逻辑
        companyAssets: 2, // 是否为公司资产 (默认 1: 是)
      },
      rules: {
        newLogicFlag: [{ required: true, message: '是否走新版逻辑', trigger: 'blur' }],
        companyAssets: [{ required: false, message: '是否为公司资产', trigger: 'change' }],
        name: [{ required: true, message: '请输入网点名称', trigger: 'blur' }],
        pwd: [{ required: false, message: '请输入网点密码', trigger: 'blur' }],
        projectLeader: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
        contactNumber: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        area: [{ required: true, message: '请选择所在地域', trigger: 'blur' }],
        refResidentialArea: [{ required: true, message: '请选择所属小区', trigger: 'blur' }],
        address: [{ required: true, message: '请填写地址', trigger: 'blur' }],
        effectiveTime: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        expireTime: [{ required: true, message: '请选择到期时间', trigger: 'blur' }],
        rent: [{ required: true, message: '请填写租金', trigger: 'blur' }],
        serviceCharge: [{ required: true, message: '请填写服务费', trigger: 'blur' }],
        payType: [{ required: true, message: '请选择付费方式', trigger: 'blur' }],
        electricCharge: [{ required: true, message: '请填写充电电费', trigger: 'blur' }],
        fullPrepayAmount: [{ required: true, message: '请填写预付费', trigger: 'blur' }],
        refBusiness: [{ required: true, message: '请选择商家', trigger: 'blur' }],
        photo: [{ required: false, message: '请上传网点图片', trigger: 'blur' }],
        userElectricCharge: [{ required: true, message: '请填写电费', trigger: 'blur' }],
        refChargePlanBatch: [{ required: true, message: '请选择充值套餐', trigger: 'blur' }]
      },
      siteDefaultParams: {},
      siteType: [],
      loading: false,
      exportQuery: {}
    }
  },
  watch: {
    regionId: {
      handler(val) {
        if (val.length) {
          this.ruleForm.area = val.at(-1)
          this.ruleForm.areaCodes = val
          console.log('regionId :>> ', val)
        }
      }
    }
  },
  methods: {
    async getSiteType(value) {
      const params = {
        pageIndex: 1,
        pageSize: 10,
        name: value
      }
      this.loading = true
      await communityListApi(params).then((res) => {
        const { records } = res.data
        this.siteType = records
        this.loading = false
        console.log('所属小区 :>> ', this.siteType)
      })
    },
    postImg(url) {
      this.ruleForm.photo = url
    },
    delImg() {
      this.ruleForm.photo = ''
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.push({ name: 'site-index' })
    },

    submitParams() {
      const params = utils.deepCopy(this.ruleForm)

      console.log('数据 :>> ', params)
      return utils.cleanObject(params)
    },
    handleCreated() {
      this.disabled = true
      addSiteApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          if (res.status === 200) this.$router.back()
        })
        .catch(() => {
          this.disabled = false
          this.$message.error('请检查填写信息')
        })
    },

    handleUpdate() {
      this.disabled = true
      updateSiteApi(this.submitParams())
        .then((res) => {
          this.disabled = false
          if (res.status === 200) {
            this.$router.push({ name: 'site-index', params: { type: 'update' } })
          }
        })
        .catch(() => {
          this.disabled = false
        })
    },
    submitForm(formName) {
      // eslint-disable-next-line consistent-return
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // eslint-disable-next-line no-unused-expressions
          this.type === 'created' ? this.handleCreated() : this.handleUpdate()
        }
      })
    },

    handleRechargeTime(val) {
      console.log('val :>> ', val)
    },
    handleAddress(val) {
      console.log('val :>> ', this.region, val)
      this.$refs.mapRef.setAddress(this.region, val)
    },

    handleMap(val) {
      console.log('经纬度 :>> ', val)
      this.ruleForm.addressLat = val.lat
      this.ruleForm.addressLon = val.lng
    },

    getMapAddress(val) {
      console.log('地图地址 :>> ', val)
      this.ruleForm.address = val
    },

    handleSearch(val) {
      this.exportQuery = { ...val }
      this.$refs.table.search(val)
    },
    handleUntieBusiness() {
      this.ruleForm.refBusiness = ''
      this.ruleForm.serviceCharge = ''
      this.ruleForm.rent = ''
    },
    handleExport() {
      const params = {
        ...this.orderDefaultParams,
        ...this.exportQuery
      }
      const { origin } = window.location
      const obj = JSON.parse(JSON.stringify(params))
      let i = ''
      let url = ''
      // eslint-disable-next-line prefer-template, guard-for-in, no-restricted-syntax
      for (i in obj) url += '&' + i + '=' + obj[i]
      const downloadUrl = `${origin}/api/chargePieOrder/exportExcel?${url}`
      console.log('host :>> ', downloadUrl)
      utils.download(downloadUrl, '网点订单列表')
    },
  },
  async created() {
    const { row, type } = this.$route.params
    console.log('row :>> ', row, type)
    if (utils.isEmptyObj(this.$route.params)) {
      this.$router.push({ name: 'site-index' })
      return
    }
    this.type = type
    if (type === 'created') {
      return
    }

    await this.getSiteType(row.refResidentialAreaName || '')
    this.ruleForm = utils.deepCopy(row)

    // 转换 companyAssets，确保是数字
    this.ruleForm.companyAssets = Number(row.companyAssets || 2)

    this.siteDefaultParams.refStore = row.code
    this.regionId = row.areaCodes
    if (type === 'watch') {
      this.disabled = true
      this.orderDefaultParams = {
        refStore: row.code
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-edit_wrapper {
  :deep(.el-radio__inner) {
    border-radius: 2px;
  }

  :deep(.el-radio__input.is-checked) .el-radio__inner::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 0;
    display: block;
    width: 10px;
    height: 5px;
    text-align: center;
    vertical-align: middle;
    background: none;
    border: 1px solid white;
    border-top: transparent;
    border-right: transparent;
    border-radius: 0;
    transform: rotate(-45deg);
  }
}
</style>
